import { useRecordContext, useTranslate } from 'react-admin';
import { useDrawer } from '@/composables/useDrawer.js';
import CustomMorePopover from '@/components/global/buttons/CustomMorePopover.jsx';
import CustomShowModalButton from '@/components/global/buttons/CustomShowModalButton.jsx';
import CustomEditModalButton from '@/components/global/buttons/CustomEditModalButton.jsx';
import { RelationLink } from '@/components/global/buttons/ListButtons.jsx';

const GroupMoreActionsPopover = ({ permissions }) => {
    const record = useRecordContext();
    const translate = useTranslate();
    const { openDrawer } = useDrawer();
    if (!record) return null;

    return (
        <>
            <CustomMorePopover permissions={permissions} record={record}>
                <CustomShowModalButton
                    onOpen={() => openDrawer(record.id, 'device-group-show')}
                    label={translate('resources.deviceGroup.labels.showDeviceGroup')}
                />
                {permissions.isAdmin && (
                    <CustomEditModalButton
                        onOpen={() => openDrawer(record.id, 'device-group-edit')}
                        label={translate('resources.deviceGroup.labels.editDeviceGroup')}
                    />
                )}
                <div className='filter-icon'>
                    <RelationLink label={translate('resources.deviceGroup.labels.viewDevicesFromGroup')} resource='device' filter='groupId_in' />
                </div>
                {permissions.isAdmin && (
                    <div className='filter-icon'>
                        <RelationLink label={translate('resources.deviceGroup.labels.viewNewDevicesFromGroup')} resource='new-device' filter='groupId_in' />
                    </div>
                )}
                <div className='filter-icon'>
                    <RelationLink
                        label={translate('resources.deviceGroup.labels.viewTransactionsFromGroup')}
                        resource='transaction'
                        filter='device->group->id_in'
                    />
                </div>
            </CustomMorePopover>
        </>
    );
};

export default GroupMoreActionsPopover;
